
import { Box } from "@mui/system";
import React from "react";
import CityList from "../Location/CityList";

const City = () => {
  return (
    <Box>
      <CityList />
    </Box>
  );
};

export default City;
